import { getAll, get } from "../utilities/querySelector";

getAll( '.imageinp' ).forEach( inpwrap => {
    const inp = get( 'input', inpwrap );
    inp.addEventListener( 'input', ( e ) => {
        const placeholder = get( '.imageinp__placeholder', inpwrap );
        const filename = inp.files?.[0]?.name;
        if ( !placeholder ) return;
        placeholder.innerHTML = filename ?? "Image Upload";
        inpwrap.dataset.chosen = !!filename;
    })
})